import { Gender } from 'common-constants/api6.types'
import { GQLGender, GQLLookFor } from 'generated-graphql/graphql'

/**
 * Если выбрано более 1 пола, сортируем так, чтобы для:
 * мужчин было: Девушку, Друга
 * женщин было: Парня, Подругу
 */
export const sortGendersLgbtFeature45 = (
  genders: GQLLookFor[],
  userGender: Gender | GQLGender
): GQLLookFor[] => {
  if (genders?.includes(GQLLookFor.F) && genders?.includes(GQLLookFor.M)) {
    const _genders = [...genders]

    switch (userGender) {
      case Gender.Male:
        return _genders.sort((gender) => (gender === GQLLookFor.F ? -1 : 1))
      case Gender.Female:
        return _genders.sort((gender) => (gender === GQLLookFor.F ? 1 : -1))
    }
  }

  return genders
}
